module.exports = __webpack_public_path__ + "static/media/create.7cf82131.webp";